module.exports = __webpack_public_path__ + "img/19.3d0931c6.jpg";